const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default (email: string): boolean => {
  return emailRegex.test(email);
};
